import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "./_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "./interopRequireDefault-d2c9da36.js";
import {_ as _extends_1, o as objectWithoutPropertiesLoose, g as createTransitions_1} from "./defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "./index-877ea290.js";
import {e as esm} from "./index-639d8dc8.js";
import {u as useTheme_1} from "./useTheme-ad5c2c5a.js";
import {u as utils} from "./utils-70a9ce59.js";
import {u as useForkRef} from "./useForkRef-b591be37.js";
import _jsxRuntime from "react/jsx-runtime";
var Fade_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _extends2 = interopRequireDefault(_extends_1);
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _useTheme = interopRequireDefault(useTheme_1);
  var _useForkRef = interopRequireDefault(useForkRef);
  const _excluded = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const styles = {
    entering: {
      opacity: 1
    },
    entered: {
      opacity: 1
    }
  };
  const defaultTimeout = {
    enter: createTransitions_1.duration.enteringScreen,
    exit: createTransitions_1.duration.leavingScreen
  };
  const Fade2 = /* @__PURE__ */ React$1.forwardRef(function Fade3(props, ref) {
    const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      TransitionComponent = esm.Transition
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const theme = (0, _useTheme.default)();
    const nodeRef = React$1.useRef(null);
    const foreignRef = (0, _useForkRef.default)(children.ref, ref);
    const handleRef = (0, _useForkRef.default)(nodeRef, foreignRef);
    const normalizedTransitionCallback = (callback) => (maybeIsAppearing) => {
      if (callback) {
        const node = nodeRef.current;
        if (maybeIsAppearing === void 0) {
          callback(node);
        } else {
          callback(node, maybeIsAppearing);
        }
      }
    };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
      (0, utils.reflow)(node);
      const transitionProps = (0, utils.getTransitionProps)({
        style,
        timeout,
        easing
      }, {
        mode: "enter"
      });
      node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
      node.style.transition = theme.transitions.create("opacity", transitionProps);
      if (onEnter) {
        onEnter(node, isAppearing);
      }
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node) => {
      const transitionProps = (0, utils.getTransitionProps)({
        style,
        timeout,
        easing
      }, {
        mode: "exit"
      });
      node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
      node.style.transition = theme.transitions.create("opacity", transitionProps);
      if (onExit) {
        onExit(node);
      }
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next) => {
      if (addEndListener) {
        addEndListener(nodeRef.current, next);
      }
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extends2.default)({
      appear,
      in: inProp,
      nodeRef,
      onEnter: handleEnter,
      onEntered: handleEntered,
      onEntering: handleEntering,
      onExit: handleExit,
      onExited: handleExited,
      onExiting: handleExiting,
      addEndListener: handleAddEndListener,
      timeout
    }, other, {
      children: (state, childProps) => {
        return /* @__PURE__ */ React$1.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0,
            visibility: state === "exited" && !inProp ? "hidden" : void 0
          }, styles[state], style, children.props.style),
          ref: handleRef
        }, childProps));
      }
    }));
  });
  var _default = Fade2;
  exports.default = _default;
});
var Fade = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _Fade.default;
    }
  });
  var _Fade = interopRequireDefault(Fade_1);
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(Fade);
export {Fade as F, __pika_web_default_export_for_treeshaking__ as _};
